import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Cable } from 'lucide-react'
import { ConnectAgentScreen } from '@/screens/develop/SCR-186-connect-agent'

export const Route = createFileRoute('/_app/connect/agent')({
  staticData: {
    screen: { id: 'SCR-186', title: 'Connect an agent', group: 'Connect', perm: 'memory.read', pin: true, order: 1, description: 'Pick your agent, create a key for it, install the integration and check that the first call arrives.', icon: Cable },
  },
  validateSearch: z.object({
    step: z.coerce.number().int().min(1).max(4).optional().transform(v => v as 1 | 2 | 3 | 4 | undefined),
    client: z.enum(['claude-code', 'cursor', 'hermes', 'mcp', 'ts', 'rest', 'python', 'cli']).optional(),
    key: z.string().max(100).optional(),
  }),
  component: ConnectAgentScreen,
})
